import React, { useState, useCallback, useEffect } from "react";
import images from "../../../../constant/images";
import { Nav } from "../../../../layouts/navbar/nav";
import countryList from "country-list";
import { useSelector, useDispatch } from "react-redux";
import {
  storePicture,
  storeSexe,
  storeCountry,
  storeCountryCode,
  storeCity,
  storePhoneNumber,
  storePhoneCode,
  storeCallingCode,
  storeAge,
  storeDateOfBirth,
} from "../../../../formSlice";
import { useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { useTranslation } from "react-i18next";

// Dummy implementations for Expo modules to preserve logic
const FileSystem = {
  getInfoAsync: async (fileURI) => {
    // Dummy: return an object with a fake file size (in bytes)
    return { size: 1000000 };
  },
};

const ImagePicker = {
  useMediaLibraryPermissions: () => [
    { status: "granted", canAskAgain: false },
    async () => ({ granted: true }),
  ],
};

const ImageManipulator = {
  manipulateAsync: async (uri, actions, options) => {
    // Dummy: return the original uri without manipulation
    return { uri };
  },
  SaveFormat: { JPEG: "jpeg" },
};

// Dummy definitions to fix ESLint errors
const Platform = { OS: "web" };

const DateTimePickerAndroid = {
  open: () => {},
  dismiss: () => {},
};

// Dummy variable for profilePic (if no image has been selected)
// const profilePic = null;

export default function StepTwo() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
  const user = localStorage.getItem("user");

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const userEmail = useSelector((state) => state.gtm.form.email);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Common states
  const [picture, setPicture] = useState("");
  const [image, setImage] = useState(null);
  const [imageMessage, setImageMessage] = useState(null);
  const [sexe, setSexe] = useState("Male");
  const [country, setCountry] = useState("Morocco");
  const [countryCode, setCountryCode] = useState("MA");
  const [city, setCity] = useState("Casablanca");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneMessage, setPhoneMessage] = useState(null);
  const [age, setAge] = useState("25-49");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [dateValidated, setDateValidated] = useState(false);
  const [dateOfBirthMessage, setDateOfBirthMessage] = useState(null);
  const [date, setDate] = useState(new Date());
  const [showPicker, setShowPicker] = useState(false);
  const [upload, setUpload] = useState(false);
  const [uploadErr, setUploadErr] = useState("");

  const [status, requestPermission] = ImagePicker.useMediaLibraryPermissions();
  const form = useSelector((state) => state.gtm.form);
  const [picturePreview, setPicturePreview] = useState("");

  // --- Web-specific functions ---
  const triggerFileInput = () => {
    document.getElementById("profileInput").click();
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];


    if (file) {
      const imageUrl = URL.createObjectURL(file);

      setPicturePreview(imageUrl);

      // Options for resizing/compressing the image
      const options = {
        maxWidthOrHeight: 200,
        useWebWorker: true,
        initialQuality: 0.8,
      };

      try {
        // Compress and resize the image
        const compressedFile = await imageCompression(file, options);

        // setPicture(compressedFile);
        // Get the extension (or you can derive it from file.type)
        const ext = compressedFile.name.split(".").pop();


        // MIME type
        const type = compressedFile.type;


        // Optionally, create a URL for the compressed file if needed
        const manipulatedUrl = URL.createObjectURL(compressedFile);


        // Set the processed image in state (store the File object for upload)
        setImage({
          uri: manipulatedUrl,
          name: `${userEmail}.${ext}`,
          type: type,
          file: compressedFile,
        });
      } catch (error) {
        console.error("Image compression error:", error);
      }
    }
  };

  const onChange = (selectedDate) => {
    const birthDate = new Date(selectedDate);
    const today = new Date();
    let computedAge = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      computedAge--;
    }
    if (computedAge < 25) {
      setDateOfBirthMessage(
        "Users under 25 years old cannot complete registration."
      );
      setDateValidated(false);
    } else {
      setDateValidated(true);
      setDateOfBirthMessage(null);
    }

    setDate(selectedDate);
    setDateOfBirth(
      new Date(selectedDate).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
    );
  };

  const pickImage = async () => {

  };
  useEffect(() => {
    if (user) {
      navigate("/home"); // or your desired route
    }
  }, [user, navigate]);

  const handleSubmit = () => {
    const numbers = /^[0-9]+$/;
    if (image) {
      dispatch(storePicture(image));
      setImageMessage(null);
    } else {
      setImageMessage("Profile picture is required.");
    }
    dispatch(storeSexe(sexe));
    dispatch(storeCountry(country));
    dispatch(storeCity(city));
    if (!numbers.test(phoneNumber)) {
      setPhoneMessage("Phone number should contain only numbers.");
      return;
    } else {
      if (phoneNumber) {
        dispatch(storePhoneNumber(phoneNumber));
        setPhoneMessage(null);
      } else {
        setPhoneMessage("Phone number is required.");
      }
    }
    dispatch(storeAge(age));
    if (dateOfBirth) {
      if (dateValidated) {
        dispatch(storeDateOfBirth(dateOfBirth));
        setDateOfBirthMessage(null);

      } else {
        setDateValidated(false);

      }
    } else {
      setDateOfBirthMessage("Date of birth is required.");
      setDateValidated(false);
    }

    if (image && phoneNumber && dateOfBirth && dateValidated) {
      navigate("/register/stepThree");
    }
  };

  useEffect(() => {


    const currentDate = new Date();

  }, []);

  //   const [fname, setFname] = useState("");
  //   const [lname, setLname] = useState("");
  //   const [email, setEmail] = useState("");
  //   const [password, setPassword] = useState("");
  //   const [passwordConfirmation, setPasswordConfirmation] = useState("");

  // useEffect(() => {
  //   setFname(localStorage.getItem("fname") || "");
  //   setLname(localStorage.getItem("lname") || "");
  //   setEmail(localStorage.getItem("email") || "");
  //   setPassword(localStorage.getItem("password") || "");
  //   setPasswordConfirmation(localStorage.getItem("passwordConfirmation") || "");
  // }, []);

  const countries = countryList.getNames();




  return (
    <div
      className="flex flex-col gap-12"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <Nav />
      <div className="flex items-center justify-center w-full mb-32">
        <div className="shadow-custom bg-white p-6 md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center">
          <h3 className="text-2xl sm:text-3xl mb-6 sm:mb-8 font-semibold text-black">
            {t("step_one.register")}
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-between w-full max-w-[90%] mx-auto mb-6 gap-3 md:gap-5 text-center md:text-start">
            <p className="text-[#0076b2] font-semibold text-lg md:text-xl flex-1">
              {t("step_two.profile_photo")}
            </p>

            <input
              id="profileInput"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleImageChange}
            />

            <div
              className="relative w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden cursor-pointer flex-shrink-0"
              onClick={triggerFileInput}
            >
              <img
                src={picturePreview || images.profil_pic}
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>

            <p className="w-full md:w-[160px] font-semibold text-[10px] flex-1">
              {t("step_two.upload_photo")}
            </p>
          </div>
          <p className="text-red-500 text-xs text-start">{imageMessage}</p>

          <div className="mb-6 relative w-full">
            {/* <span className="absolute left-[30%] sm:left-[20%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
              *
            </span> */}
            <select
              value={sexe}
              onChange={(e) => setSexe(e.target.value)}
              className="w-full bg-[#F4F5F9] rounded-xl p-3"
            >
              <option selected hidden disabled>
                {t("step_two.gender")}
              </option>
              <option>{language === "fr" ? "Homme" : "Male"}</option>
              <option>{language === "fr" ? "Femme" : "Female"}</option>
            </select>
          </div>

          <div className="mb-6 relative w-full">
            {/* <span className="absolute left-[35%] sm:left-[25%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
              *
            </span> */}
            <select
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              className="w-full bg-[#F4F5F9] rounded-xl p-3"
            >
              <option selected disabled value="">
                {t("step_two.country")}
              </option>
              {countries?.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6 relative w-full">
            {/* <span className="absolute left-[50%] sm:left-[30%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
              *
            </span> */}
            <input
              type="text"
              className="w-full bg-[#F4F5F9] rounded-xl p-3"
              placeholder={t("step_two.city")}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>

          <div className="mb-6 relative w-full">
            {/* <span className="absolute left-[75%] sm:left-[45%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
              *
            </span> */}
            <input
              type="tel"
              className="w-full bg-[#F4F5F9] rounded-xl p-3"
              placeholder={t("step_two.phone_number")}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            {phoneMessage && (
              <p className="text-red-500 text-xs text-start">{phoneMessage}</p>
            )}
          </div>

          <div className="md:flex md:flex-row flex gap-5 flex-col md:gap-4 mb-6">
            <div className="w-full flex flex-col md:w-1/2 relative">
              <span className="absolute left-[30%] sm:left-[35%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                *
              </span>
              <select
                className="w-full bg-[#F4F5F9] rounded-xl p-3"
                onChange={(e) => setAge(e.target.value)}
              >
                <option selected disabled value="">
                  Age
                </option>
                <option>25-49</option>
                <option>50+</option>
              </select>
            </div>
            <div className="w-full flex flex-col md:w-1/2 relative">
              <span className="absolute left-[45%] sm:left-[50%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                *
              </span>
              <input
                type="date"
                // value={date}
                className="w-full bg-[#F4F5F9] rounded-xl p-3"
                onChange={(e) => onChange(e.target.value)}
              />
              {dateOfBirthMessage && (
                <p className="text-red-500 text-xs text-start">
                  {dateOfBirthMessage}
                </p>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-black font-semibold border-none cursor-pointer mx-auto block hover:bg-[#333] text-white"
            onClick={handleSubmit}
          >
            {language === "fr" ? "Suivant" : "Next"}
          </button>

          {/* Footer Text */}
          {/* <div className="text-[7px] xs:text-xs sm:text-[12px] text-center text-[#666] pt-[40px]">
              {t("login.help_message")} <br className="hidden xs:block" />
              {language === "fr" ? "Voir les" : "See the"}{" "}
              <a
                href="/termes-et-conditions"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions d'utilisation"
                  : "Terms of Use"}
              </a>
              ,{" "}
              <a
                href="/conditions-de-notification"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de notification"
                  : "Notification conditions"}
              </a>
              ,{" "}
              <a
                href="/conditions-de-paiement"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de paiement"
                  : "Payment conditions"}
              </a>
              {language === "fr" ? ", et la" : ", and"}{" "}
              <a
                href="/politique-de-confidentialite"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "politique de confidentialité"
                  : "Privacy Policy"}
              </a>
              .
            </div> */}
        </div>
      </div>
    </div>
  );
}
